export const LINKBILLETERA = 'https://billetera.foxplor.app'